// Features/Accessories-Product/mod.ts
import { renderSection } from "Render";
import { trackAccessorySelected } from "Analytics";
var Selector_Selection = `.Accessories-Product-Selection`;
var Selector_Estimate = `quantity-input`;
var Selector_Details = `.Accessories-Product-Details`;
var Selector_Section = `accessories-section`;
var Selector_Summary = `.Accessories-Summary-Wrapper`;
var Selector_Fold = `accessories-fold`;
var Selector_Accordion = `.Popup-Block .Accessories-Accordion`;
var Selector_Pairing = `.Popup-Block .Accessories-Pairing button`;
var Selector_Preview = `.Popup-Block .Accessories-Preview`;
var Selector_Popup = `#Accessories-Popup`;
var Selector_Quantity = `.ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity`;
var Selector_Minus = `.ProductForm__QuantitySelector .product-minus`;
var Selector_Plus = `.ProductForm__QuantitySelector .product-plus`;

class Product extends HTMLElement {
  estimate;
  section;
  summary;
  details;
  select;
  fold;
  accordion;
  pairing;
  preview;
  popup;
  quantity_input;
  quantity_minus;
  quantity_plus;
  data;
  constructor() {
    super();
    this.data = JSON.parse(this.querySelector(`[ type = 'application/json' ]`).innerText);
    this.quantity_input = document.querySelector(Selector_Quantity);
    this.quantity_minus = document.querySelector(Selector_Minus);
    this.quantity_plus = document.querySelector(Selector_Plus);
    this.popup = document.querySelector(Selector_Popup);
    this.accordion = this.popup.querySelector(Selector_Accordion);
    this.preview = this.popup.querySelector(Selector_Preview);
    this.pairing = this.popup.querySelector(Selector_Pairing);
    this.estimate = this.querySelector(Selector_Estimate);
    this.details = this.querySelector(Selector_Details);
    this.section = this.closest(Selector_Section);
    this.select = this.querySelector(Selector_Selection);
    this.fold = this.closest(Selector_Fold);
    this.summary = this.section.querySelector(Selector_Summary);
  }
  connectedCallback() {
    this.quantity_input.addEventListener("keyup", () => this.updateEstimateFromInput());
    this.quantity_minus.addEventListener("click", () => this.updateEstimateFromInput());
    this.quantity_plus.addEventListener("click", () => this.updateEstimateFromInput());
    this.select.addEventListener("click", () => this.toggleSelection());
    this.details.addEventListener("click", () => this.openDetails());
    this.updateEstimate(1);
  }
  get variantId() {
    return this.data.variantId;
  }
  get items() {
    const { units, data } = this;
    if (!data.soldInUnits)
      return units;
    const { unitsInItem } = data.price;
    return Math.ceil(units / unitsInItem);
  }
  get units() {
    return this.estimate.value;
  }
  get fold_type() {
    return this.fold.dataset.collection;
  }
  toggleSelection() {
    const isSelected = this.dataset.isSelected === "true";
    this.dataset.isSelected = String(!isSelected);
    this.fold.updateSelection();
    this.section.updateSelection();
    if (!isSelected)
      trackAccessorySelected({ fold: this.fold_type });
  }
  async openDetails() {
    const { popup } = this.popup;
    popup.loading = true;
    this.pairing.onclick = () => {
      popup.close();
      setTimeout(() => this.summary.scrollIntoView({
        behavior: "smooth",
        block: "start"
      }), 50);
      setTimeout(() => this.toggleSelection(), 600);
    };
    this.preview.innerHTML = "";
    this.pairing.parentElement.dataset.isSelected = this.dataset.isSelected;
    popup.open();
    await this.renderPreview();
    this.registerPreview();
    this.updatePaired();
    popup.loading = false;
  }
  updateEstimateFromInput() {
    setTimeout(() => {
      const quantity = parseInt(this.quantity_input.value);
      this.updateEstimate(quantity);
    }, 0);
  }
  updateEstimate(quantity) {
    let value = 1;
    switch (this.data.estimateType) {
      case "Area":
        value = quantity;
        break;
      case "Border":
        value = quantity;
        break;
    }
    this.estimate.value = value;
  }
  updatePaired() {
    const paired = this.preview.querySelector(`paired-quantity`);
    if (!paired) {
      console.error(`Paired quantity element is missing!`);
      return;
    }
    const { price } = this.data;
    console.debug("Prices", this.data, this.units);
    paired.quantity = this.items;
    paired.price = this.items * price.item.current;
    paired.unit = price.item.name;
  }
  async render(type) {
    return await renderSection({
      section: type,
      at: `products/${this.data.handle}`
    });
  }
  async renderPreview() {
    this.preview.innerHTML = await this.render("render-product-details");
  }
  registerPreview() {
    const section = this.preview.querySelector(`[ data-section-id ]`);
    if (!section) {
      console.error(`Failed to find section node for registering product preview`);
      return;
    }
    const { sections } = window;
    const constructor = sections.constructors["product"];
    sections._createInstance(section, constructor);
  }
}
customElements.define("accessories-product", Product);
export {
  Product as AccessoriesProduct
};
